import React, { useCallback, useState } from "react";
import CtoSelect from '../../../../components/CtoSelect'
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Step, StepLabel, Stepper, TextField } from "@mui/material";
import { useFormError } from "../../../../components/Datatable/FormErrorProvider";
import api from "../../../../services/api";
import { useNotify } from "../../../../components/Datatable/NotifyProvider";
import FreeOnuSelect from "../FreeOnuSelectDetail";
import { SearchRounded } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import ProfileSelect from "../../../../components/ProfileSelect";
import FreeOnuSelectSimple from "../FreeOnuSelectSimple";
import CustomTextField from "../../../../components/CustomTextField";
import ProvisioningProgressModal from "../../../../components/ProvisioningProgressModal";


function genTaskId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, "").slice(0, 8);
  return Math.random().toString(16).slice(2, 10);
}


export default function RemSimple() {
  const error = useFormError()
  const [taskId, setTaskId] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [result, setResult] = useState(null)
  const [searchOnu, setSearchOnu] = useState(false)




  const fetchRem = () => {
    error.setErrors([])
    const tid = genTaskId()
    setTaskId(tid)
    setResult(null)
    setModalOpen(true)
    const snap = { ...state }
    api.post(`provisioning/olt/rem/simple/?task_id=${tid}`, state)
      .then(res => {
        if (res.data.error) {
          setResult({ ok: false, message: res.data.error })
          return
        }
        if (res.data.errors) {
          setModalOpen(false)
          error.setErrors(res.data.errors)
          return
        }

        setResult({
          ok: true,
          message: "ONU removida com sucesso",
          info: [
            { label: "SN", value: snap.sn },
            { label: "CTO", value: snap.cto },
          ],
        })
        setState({
          sn: null,
          cto: null

        })
      }

      )
      .catch(e => {
        setResult({ ok: false, message: "Falha: " + (e?.message || e) })
      })
  }
  const [state, setState] = useState({
    sn: null,
    cto: null
  })
  const notify = useNotify()

  const handleState = useCallback((event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  }, [state])


  return (
    <Box display={"flex"}
     flexWrap={'wrap'} flexDirection={"column"} justifyContent={"center"}
     gap={1}
      sx={{
        width: { xs: "auto", sm: "auto", md: 400 }
      }}
    >

      <CtoSelect
        fullwidth
        size="small"
        sx={{


        }}
        value={state.cto}
        handler={(e) => { setState({ ...state, cto: e }) }}
        admin={false}
      />


      <CustomTextField
        size="small"
        fullwidth
        error={error.verify('sn')}
        helperText={error.msgError('sn')}
        label='SN'
        value={state.sn}
        name={'sn'}
        onChange={handleState}
        type="text"
      />




      <Button variant="contained" onClick={fetchRem}>{"Remover"}</Button>

      <ProvisioningProgressModal
        open={modalOpen}
        taskId={taskId}
        mode="user"
        streamPath="/provisioning/stream"
        result={result}
        onClose={() => { setModalOpen(false); setResult(null) }}
      />

    </Box >

  )
}